<template>
    <v-card>
      <v-card-title primary-title class="py-2">
        <div class="subheading">
          {{ $t("view.commons.records") }}
        </div>
        <v-spacer />
        <v-btn icon @click="view.elem.datatable.visible = !view.elem.datatable.visible">
          <v-icon>{{ view.elem.datatable.visible ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-fade-transition>
        <v-card-text v-show="view.elem.datatable.visible" class="pt-0">
          <v-layout row wrap>
            <v-flex md12>
              <v-data-table
                ref="dataTable"
                item-key="clave"
                class="partner dataTable"
                sort-by="clave"
                :sort-desc="false"
                :headers="view.elem.datatable.headers"
                :items="view.elem.datatable.data"
                :loading="view.elem.datatable.loading"
                :footer-props="view.elem.datatable.footerprops"
                :must-sort="true"
                :server-items-length="view.elem.datatable.total"
                :options.sync="options">
                <template #top>
                  <v-text-field v-model.trim="search" dense hide-details :label="$t('view.commons.search')" append-icon="mdi-magnify" />
                </template>

                <template #item.accion="{ item }">
                  <buttons
                    :ref="`dataTableBtn_${item.clave}`"
                    :key="refreshkey"
                    :clave="item.clave"
                    :descripcion="item.descripcion"
                    :showdisable="item.status && $userPermission.hasPermission('ROLE_MODIFICAR_OP')"
                    @edit="edit"
                    @disable="disable"
                    @audit="audit" />
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-fade-transition>
    </v-card>
  </template>

<script>
import PartnerAPI from "@/services/operativos/partner"; /** *******************************/
import Buttons from "@/components/datatable/Buttons"; /** *******************************/
import transform from "@/helpers/server-side-datatable";
import tippy from "tippy.js";
import { disableSwal } from "@/constants/sweet-alerts";
import { handleResponse } from "@/helpers/http-response-handler";

export default {
  name: "DataTable"
  , components: { Buttons }
  , data() {
    return {
      options: {}
      , filtros: {}
      , search: ""
      , refreshkey: 0
      , view: {
        elem: {
          datatable: {
            visible: true
            , loading: false
            , data: []
            , total: 0
            , footerprops: { showFirstLastPage: true, "items-per-page-options": [10, 25, 50, 100] }
            , headers: [
              { text: this.$t("view.commons.clave"), align: "left", sortable: true, class: "clave", cellClass: "clave", value: "clave" }
              , { text: this.$t("view.operativos.partner.form.descripcion.th"), align: "left", sortable: true, class: "descripcion", cellClass: "descripcion", value: "descripcion" }
              , { text: this.$t("view.commons.accion"), align: "center", sortable: false, class: "accion", cellClass: "accion", value: "accion" }
            ]
          }
        }
      }
    };
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
    , search: {
      handler() {
        this.options.page = 1;
        this.load();
      }
      , deep: true
    }
  }
  , updated() {
    tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
  }
  , methods: {
    prepareData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let serverSideData = {};
      serverSideData.draw = "0";
      serverSideData.filters = JSON.stringify(this.filtros);
      serverSideData.start = page;
      serverSideData.length = itemsPerPage;
      serverSideData.search = { value: this.search ? this.search : "", regex: false };
      serverSideData.order = { column: sortBy, dir: sortDesc };
      serverSideData.columns = this.view.elem.datatable.headers;
      return transform.transformServerSideRequest(serverSideData);
    }
    , async load() {
      if (!this.filtros || this.filtros == {}) return false;

      this.view.elem.datatable.loading = true;

      const serverSideDataT = this.prepareData();
      const response = await PartnerAPI.list(serverSideDataT);
      const { data, recordsTotal } = response.data;

      this.view.elem.datatable.data = data;
      this.view.elem.datatable.total = Number(recordsTotal);
      this.refreshkey += 1;

      this.view.elem.datatable.loading = false;
    }
    , async edit(clave) {
      this.$emit("editRow", clave);
    }
    , async disable(clave) {
      if ((await this.$swal(disableSwal)).value) {
        if (handleResponse(await PartnerAPI.disable({ clave }))) {
          this.load();
          if (clave == this.$parent.partner.clave) this.$emit("editRow", clave);
        }
      }
    }
    , async audit(clave, descripcion) {
      this.$emit("auditRow", clave, descripcion);
    }
    , refreshData() {
      this.load();
    }
  }
};
</script>

  <style>
  .dataTable.partner {
    width: 100%;
  }
  </style>



// WEBPACK FOOTER //
// src/views/operativos/partner/DataTable.vue